import { action, makeObservable, observable } from 'mobx';

export interface IResponseOverride {
    id: string;
    name: string;
    policyId: string;
    ruleId: string;
    killProcess?: boolean;
    isolateHost?: boolean;
    quarantineFile?: boolean;
    recommendedResponses?: boolean;
}

export default class ResponseOverrideStore {
    responseOverride: IResponseOverride = {
        id: '',
        name: '',
        policyId: '',
        ruleId: '',
        killProcess: false,
        isolateHost: false,
        quarantineFile: false,
        recommendedResponses: false
    };

    constructor(responseOverride: IResponseOverride) {
        makeObservable(this, {
            responseOverride: observable,
            update: action
        });

        this.update(responseOverride);
    }

    update(responseOverride: IResponseOverride) {
        this.responseOverride = {
            ...this.responseOverride,
            ...responseOverride
        };
    }
}
